import { Component, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";
import EventData from "../EventData/EventData.vue";
import EventTitle from "../EventTitle/EventTitle.vue";
import {
  EMITTED_EVENT,
  ICONS_COLORS,
  MAIN_FILTER
} from "../../constants/EventConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Event } from "../../models/event.model";

Vue.use(Vuetify);

@Component({
  name: "EventCard",
  components: {
    EventData,
    EventTitle
  }
})
export default class EventCard extends Vue {
  @Prop({ default: {} }) private event!: Event;

  showInformation = false;

  cardClass = STYLE_CLASSES.CARD;

  DOCUMENT_EVENT = MAIN_FILTER.DOCUMENT;
  ICON_COLORS = ICONS_COLORS;

  showDetails() {
    this.showInformation = true;
  }

  hideDetails() {
    this.showInformation = false;
  }

  hideBlueDot() {
    this.event.isNew = false;
  }

  showNotes() {
    this.$emit(EMITTED_EVENT.SHOW_NOTES);
  }

  hideNotes() {
    this.$emit(EMITTED_EVENT.HIDE_NOTES);
  }

  showPreview() {
    this.$emit(EMITTED_EVENT.SHOW_PREVIEW);
  }

  hidePreview() {
    this.$emit(EMITTED_EVENT.HIDE_PREVIEW);
  }
}
